<template>
  <div class="header" @click="dropdownOpen = false">
    <!--
    <img @click="goToHome()" class="gohome" :src="require('../../../assets/images/logoMonPermis.png')" />
-->
    
    <div class="header-row">
      <div class="headerNav headerNavChoix">
        <div class="mode">
          <div class="titlePart">
            <span>1. Mode Planning</span>
          </div>
          <div class="contentPart">
            <select name="" id="" @change="setAuto" v-model="auto">
              <option :value="true">AUTO</option>
              <option :value="false">MANUEL</option>
            </select>
          </div>
        </div>

        <div class="resa">
          <div class="titlePart">
            <span>2. Mode Réservation</span>
          </div>
          <div class="contentPart">
            <select name="" id="" v-model="this.$store.state.modeResa" @change="setModeResa">
              <option value="INDISPO MONO">INDISPO MONO</option>
              <option value="RESA ELEVE">RESA ELEVE</option>
              <option value="EXAMEN BLANC">EXAMEN BLANC</option>
              <option value="EXAMEN">EXAMEN</option>
              <option value="SEMAINE TYPE">SEMAINE TYPE</option>
            </select>
          </div>
        </div>

        <div class="eleveSelec">
          <div class="titlePart">
            <template v-if="this.$store.state.planningSelectChoice === 'SEMAINE TYPE'">
              <span>3. Sélection Moniteur</span>
            </template>
            <template v-else>
              <span>3. Séléction Elève</span>
            </template>
          </div>

          <div class="contentPart heuresDispoSemaineWrap" v-if="this.$store.state.planningSelectChoice === 'SEMAINE TYPE'">
            <select name="moniteurSemaineType" id="moniteurSemaineType" v-model="moniteurSelectId" @change="selectMoniteurSemaineType">
              <option :value="null">Choisir un moniteur</option>
              <template v-for="m in moniteurs" :key="m.idMono">
                <option :value="m.idMono">{{ m.fullname }}</option>
              </template>
            </select>
            <span class="heuresDispoSemaineBadge" v-if="moniteurSelectId !== null && heuresDispoSemaineType !== null">
              {{ formatHeuresDispo(heuresDispoSemaineType) }}h de créneau dispo / semaine
            </span>
          </div>

          <div class="contentPart containername" v-if="this.$store.state.showSearchEleve && this.$store.state.planningSelectChoice !== 'SEMAINE TYPE'">
              <SimpleTypeahead
                id="typeahead_id"
                placeholder="Rechercher un élève..."
                :key="typeaheadKey"
                :items="leleves"
                :defaultItem="eleve && eleve.fullname ? eleve : null"
                :minInputLength="1"
                :itemProjection="
                  (item) => {
                    return item.fullname;
                  }
                "
                @selectItem="selectItem"
                @onInput="searchEleve"
              >
              </SimpleTypeahead>

              <div>
                <button class=" btn-primary" v-if="showBtn" @click="cancelChoice">X</button>
              </div>
          </div>
        </div>
      </div>

      <div class="headerNav headerNavEleve">
        <div class="eleveSelecInfo">
          <div class="titlePart" v-if="showBtn && eleve !== ''">
            <span>{{ eleve.nom }} {{ eleve.prenom }}</span>
            <span class="eleveTel">TEL : {{ eleve.telephone }}</span>
          </div>
          <div class="titlePart" v-else>
            <span>Aucun élève sélectionné</span>
          </div>

          <div class="select" v-if="showBtn">
            <div class="select-group">
              <span class="select-group-label">Niveau de formation</span>
              <div class="select-group-items">
                <button class="btn btn-primary" @click="goToFicheEleve">{{this.eleve.tramePourcent}}%</button>
                <button class="btn btn-danger" @click="showExamModal = true;">EXAM</button>
              </div>
            </div>

            <div class="select-divider"></div>

            <div class="select-group">
              <span class="select-group-label">Nb heures à programmer</span>
              <div class="select-group-items">
                <div class="heure-equation">
                  <div class="heure-box heure-box-clickable" @click="showTrameDialog = true">
                    <span class="heure-box-value">{{ eleve.heureRestanteTrame }}h</span>
                    <span class="heure-box-label">H pour finir</span>
                  </div>
                  <span class="heure-op">-</span>
                  <div class="heure-box heure-box-clickable" @click="showHeuresProgrammeesDialog = true">
                    <span class="heure-box-value">{{ heureProgrammeesEleve }}h</span>
                    <span class="heure-box-label">{{ heureProgrammeesLabel }}</span>
                  </div>
                  <span class="heure-op">=</span>
                  <div class="heure-box heure-box-highlight">
                    <span class="heure-box-value">{{ heureAProgEleve }}h</span>
                    <span class="heure-box-label">H à programmer</span>
                  </div>
                  <button class="btn btn-success accActiv" @click="cancelAcc" disabled v-if="this.eleve.acc == true"><img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                </div>
                <button class="btn btn-primary" disabled v-if="eleve.simuHeuresRestantes > 0">Simu : {{ eleve.simuHeuresRestantes }}h</button>
              </div>
            </div>

            <div class="select-divider"></div>

            <div class="select-group">
              <span class="select-group-label">Solde</span>
              <div class="select-group-items">
                <div class="solde-card" id="btnSolde" @click="showSolde">
                  <span class="solde-card-value">{{ formatSolde(eleve.solde) }} €</span>
                </div>
              </div>
            </div>

            <div class="select-divider"></div>

            <div class="select-group">
              <span class="select-group-label">Type de formation</span>
              <div class="select-group-items">
                <template v-if="eleve.boite == null">
                  <button class="btn btn-primary" @click="showBoite">BA OU BM ?</button>
                </template>
                <template v-else-if="eleve.boite == 1">
                  <button class="btn btn-success" @click="changeBoite(2)">BA</button>
                </template>
                <template v-else-if="eleve.boite == 2">
                  <button class="btn btn-danger" @click="changeBoite(1)">BM</button>
                </template>

                <template v-if="this.eleve.aac">
                  <button class="btn btn-success" @click="unSetAac"><img src="../../../assets/images/conduite/aac.png" class="logoaac" alt=""></button>
                </template>
                <template v-else>
                  <button class="btn btn-primary" @click="this.aacBtn = true;"><img src="../../../assets/images/conduite/aac.png" class="logoaac" alt=""></button>
                </template>

                <button class="btn btn-primary" @click="choiceDispo">DISPO</button>
              </div>
            </div>
          </div>
          <div v-if="showBtn && eleve.exam !== ''">
            <p>Exam : {{eleve.exam}}</p>
          </div>
        </div>

        <div class="user">
          <div class="btnSemaine">
            <button class="btn btn-primary" @click="openSemaineHeuresDialog">SEMAINE</button>
          </div>

          <div class="btnMono">
            <button class="btn btn-primary" @click="showMono(true)">MONO</button>
          </div>

          <div class="pageInfo">
            <div class="dropdown" :class="{ 'is-open': dropdownOpen }" @click.stop="dropdownOpen = !dropdownOpen">
              <button class="btn btn-primary profileBtn"><img @click="goToHome()" class="goProfile" :src="require('../../../assets/images/conduite/profile.png')" /></button>
              <div class="dropdown-content" @click.stop="dropdownOpen = false">
                <router-link to="/home"><a href="#">Accueil</a></router-link>
                <div class="subMenu">
                    <div class="subTitleMenu">
                      <a>LEGENDE</a>
                    </div>
                    <div class="subMenus">
                      <p>LEGENDE :</p>
                      <div class="color">
                        <div class="squareColor cba"></div>
                        <p>: RDV BA</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cbm"></div>
                        <p>: RDV BM</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cdone"></div>
                        <p>: RDV FINI</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cCancelEleve"></div>
                        <p>: ANNULE ELEVE 48h</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cIncident"></div>
                        <p>: INCIDENT</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cIndispo"></div>
                        <p>: INDISPO MONO</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cIndispoMonoPerma"></div>
                        <p>: INDISPO MONO PERMA</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cExam"></div>
                        <p>: EXAM</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cEb"></div>
                        <p>: EXAM BLANC</p>
                      </div>
                      <div class="color">
                        <div class="squareColor cDispoEleve"></div>
                        <p>: DISPO ELEVE</p>
                      </div>
                    </div>
                </div>

                <a @click="setSplitScreen('simu')">SIMULATEUR</a>
                <a @click="setSplitScreen('DISPO ELEVES')">DISPO Eleves</a>
                <a @click="setSplitScreen('H à pgmer')">H à pgmer</a>
                <a @click="setSplitScreen('RDV AAC')">RDV AAC</a>
                <a @click="setSplitScreen('HEURE ET EMARGEMENT')">Heure et émargement</a>
                <router-link to="/agence/exam/conduite"><a href="#">EXAMEN</a></router-link>
                <a href="#" @click="deconnexion">Déconnexion</a>
              </div>
            </div>



          </div>

        </div>
      </div>
    </div>


    <Dialog v-model:visible="showSimuPopup" modal header="Simulateur - Liste des élèves" :style="{ width: '80rem' }">

      <div class="selector">
        <select name="getCode" id="getCode" class="selectSimu" @change="getCodeResultSimu">
          <option value="null">Resultat Code</option>
          <option value="true">Oui</option>
          <option value="false">Non</option>
        </select>

        <div class="containername">
          <SimpleTypeahead
            id="typeahead_id"
            placeholder="Rechercher un élève..."
            :items="simuEleves"
            :minInputLength="1"
            :itemProjection="
              (item) => {
                return item.fullname;
              }
            "
            @selectItem="selectItemSimu"
          >
          </SimpleTypeahead>
          <button class=" btn-primary" v-if="showCancelBtnSimu" @click="cancelChoiceSimu">X</button>
        </div>

      </div>



      <DataTable           
          :value="this.simuEleves"
          v-model:selection="eleveSelectSimu"
          selectionMode="single"
          tableStyle="min-width: 80rem"
          @click="selectSimu"
          paginator
          :rows="10"
          :rowsPerPageOptions="[10, 20, 50]">
        <Column field="fullname" header="Nom"  ></Column>
        <Column field="scoreDerniersTest" header="Score 5 derniers tests"  sortable></Column>
        <Column field="code" header="Resultat Code"  ></Column>
        <Column field="nbRdv" header="Nombre de RDV restant"  ></Column>
      </DataTable>
    </Dialog>

    <Dialog v-model:visible="droitBtn" modal header="Droits" :style="{ width: '50rem' }">
      <div class="droitsModal">
        <p>
          Droits =
        </p>
        <input type="number" name="droit" id="droit" v-model="droitNumber">
        <p>Heures/Semaine</p>
      </div>
      <template v-if="loadDroitBtn == false">
        <button class="btn btn-primary btnValideDroit" @click="setDroit">VALIDER</button>
      </template>
      <template v-else>
        <button @click="setDroit()" class="btn btn-primary btnValideDroit" disabled><span><i class="fa fa-spinner fa-spin"></i>VALIDER</span></button>
      </template>

    </Dialog>

    <Dialog v-model:visible="soldeBtn" modal :header="headerSolde" :style="{ width: '80%' }" class="solde-dialog">

      <template #header>
        <div class="headSolde">
          <h3>{{ this.eleve.fullname }}</h3>
          <button class="btn btn-primary btnSwitchSolde" @click="changeSoldBtn" v-if="soldeSoldebtn">Heures ></button>
          <button class="btn btn-primary btnSwitchSolde" @click="changeSoldBtn" v-if="soldeRdvBtn">&lt; Solde</button>
        </div>
      </template>

      <div class="soldePage" v-if="soldeSoldebtn">
        <paiement :data="eleve" :modal="true"/>
      </div>
      <div class="rdvPage" v-if="soldeRdvBtn">
        <div class="table-wrap table-wrap--modal">
        <DataTable :value="rdvsHistorique" tableStyle="width: 100%; min-width: 50rem" responsiveLayout="scroll" class="heures-prog-table" :rowClass="rdvsHistoriqueRowClass">
          <Column header="Type">
            <template #body="slotProps">
              <span v-if="slotProps.data.id === rdvsHistoriqueFinTheoriqueId" class="type-badge type-badge--fin-theorique">
                Fin théorique de formation
              </span>
              <button
                v-else-if="rdvsHistoriqueRdvpEligibleIds.includes(slotProps.data.id)"
                class="btn-passer-rdvp"
                type="button"
                @click="passerEnRdvPrealable(slotProps.data)"
              >
                Passer en RDV préalable
              </button>
              <span v-else-if="slotProps.data.cancelRdv != null" class="type-badge type-badge--cancelled">{{ typeRdvLabel(slotProps.data.type) }} (Annulé)</span>
              <span v-else class="type-badge">{{ typeRdvLabel(slotProps.data.type) }}</span>
            </template>
          </Column>
          <Column field="ladate" header="Date"></Column>
          <Column field="heureDebut" header="Heure début"></Column>
          <Column field="heureFin" header="Heure fin"></Column>
          <Column field="moniteur.fullname" header="Mono"></Column>
          <Column field="lieuDeb.nom" header="Lieu début"></Column>
          <Column header="Lieu fin">
            <template #body="slotProps">{{ slotProps.data.lieuFin ? slotProps.data.lieuFin.nom : "" }}</template>
          </Column>
          <Column field="commentaire" header="Commentaire">
            <template #body="slotProps">
              <span
                v-if="slotProps.data.commentaire"
                class="commentaire-cell"
                :title="slotProps.data.commentaire"
              >{{ slotProps.data.commentaire.substring(0, 20) }}{{ slotProps.data.commentaire.length > 20 ? '…' : '' }}</span>
            </template>
          </Column>
          <Column header="Terminé">
            <template #body="slotProps">
              <template v-if="typeof slotProps.data.termine === 'boolean'">{{ slotProps.data.termine ? "Oui" : "Non" }}</template>
              <template v-else>{{ slotProps.data.termine }}</template>
            </template>
          </Column>
          <Column header="Émargement">
            <template #body="slotProps">
              <template v-if="typeof slotProps.data.emargement === 'boolean'">{{ slotProps.data.emargement ? "Oui" : "Non" }}</template>
              <template v-else>—</template>
            </template>
          </Column>
        </DataTable>
        </div>

      </div>
    </Dialog>

    <Dialog v-model:visible="paiementBtn" modal :header="this.eleve.fullname" :style="{ width: '50%' }">
      <div class="droitsModal">
        <input type="date" name="date" id="date" v-model="paiement.date">
        <input type="number" name="montant" id="montant" v-model="paiement.montant">
        <select name="mode" id="mode" v-model="paiement.mode" class="modePaiement">
          <option value="null">Mode de paiement</option>
          <option value="CB">CB</option>
          <option value="VIR">VIR</option>
          <option value="PE">PE</option>
          <option value="SUBV">SUBV</option>
          <option value="CPF">CPF</option>
        </select>
        <select name="payeur" id="payeur" v-model="paiement.payeur" class="payeurSelect">
          <option value="null">Payeur</option>
          <option value="client">client</option>
          <option value="CPF">CPF</option>
          <option value="SUBV">SUBV</option>
          <option value="PE">PE</option>
        </select>
      </div>
      <template v-if="loadPaiementBtn == false">
        <button class="btn btn-primary btnValideDroit" @click="postOtherPaiement">OK PAIEMENT REALISE</button>
      </template>
      <template v-else>
        <button @click="postOtherPaiement()" class="btn btn-primary btnValideDroit" disabled><span><i class="fa fa-spinner fa-spin"></i>OK PAIEMENT REALISE</span></button>
      </template>

    </Dialog>

    <Dialog v-model:visible="accBtn" modal :header="this.eleve.fullname" :style="{ width: '50rem' }">
      <div class="droitsModal">
        <p>Voulez-vous passer cet élève en accéléré ?</p>
      </div>
      <button class="btn btn-primary yesBtn" @click="postAac">Oui</button>
      <button class="btn btn-danger" @click="accBtn = false;">Non</button>
    </Dialog>

    <Dialog v-model:visible="aacBtn" modal :header="this.eleve.fullname" :style="{ width: '50rem' }">
      <div class="droitsModal">
        <p>Voulez-vous passer cet élève en conduite accompagné ?</p>
      </div>
      <button class="btn btn-primary yesBtn" @click="setAac">Oui</button>
      <button class="btn btn-danger" @click="this.aacBtn = false;">Non</button>
    </Dialog>

    <Dialog v-model:visible="boiteBtn" modal :header="this.eleve.fullname" :style="{ width: '50rem' }">
      <div class="droitsModal">
        <p>Voulez-vous passer cet élève en conduite boite auto ou manuelle ?</p>
      </div>
      <button class="btn btn-primary yesBtn" @click="setBoite(1)">BA</button>
      <button class="btn btn-danger" @click="setBoite(2)">BM</button>
    </Dialog>

    <Dialog v-model:visible="dispoBoite" @show="onDialogShow" modal :header="this.eleve.fullname" :style="{ width: '50rem' }" @update:visible="handleClose">
      <DispoModalEleve ref="calendarComponent" :eleve="this.eleve" @getAllEleves="getAllEleves" @dispoIsUpdate="dispoIsUpdate"/>
    </Dialog>

    <Dialog v-model:visible="showChoixEleve" modal :header="this.eleve.fullname" :style="{ width: '90rem' }" >
      <Moniteurs         
        :eleve="eleve"
        :choixDispo="eleve.choixDispo[0]"
        @getEleveInfo="getAllEleves"
        @setNewChoixDispo="setNewChoixDispoEleve"
        @closeModalChoixEleve="closeModalChoixEleve"
        :modalChoixEleve="true"
      />
    </Dialog>

    <Dialog v-model:visible="showChangeBoiteModal" modal header="Changement de boîte de vitesse" :style="{ width: '90rem' }" @update:visible="handleCloseChangeBoite" >
      <!--
        <div class="changeBoite changeBoiteFirst" v-if="changeBoiteStep == 1">
          <h1 v-if="eleve.boite == 1">Voulez-vous passer {{ this.eleve.fullname }} en BM ?</h1>
          <h1 v-else>Voulez-vous passer {{ this.eleve.fullname }} en BA ?</h1>
          <div class="choix">
            <button class="btn btn-primary" @click="this.changeBoiteStep = 2;">OUI</button>
            <button class="btn btn-danger" @click="this.changeBoiteStep = 1; this.showChangeBoiteModal = false;">NON</button>
          </div>
        </div>

        <div class="changeBoite changeBoiteSecond" v-if="changeBoiteStep == 2">
          <h1>Toutes les heures de l'élève vont être supprimées, êtes-vous sûr?</h1>
          <div class="choix">
            <button class="btn btn-danger" @click="this.changeBoiteStep = 1; this.showChangeBoiteModal = false;">NON</button>
            <button class="btn btn-primary" @click="this.changeBoiteStep = 3;">OUI</button>
          </div>
        </div>

        <div class="changeBoite changeBoiteThrid" v-if="changeBoiteStep == 3">
          <h1 v-if="eleve.boite == 2">Vous êtes sur le point de supprimer toutes les heures à venir de {{ this.eleve.fullname }}, il passera alors en BA</h1>
          <h1 v-else>Vous êtes sur le point de supprimer toutes les heures à venir de {{ this.eleve.fullname }}, il passera alors en BM</h1>
          <div class="choix">
            <button class="btn btn-primary" @click="changeTypeBoiteEleve">OUI</button>
            <button class="btn btn-danger" @click="this.changeBoiteStep = 1; this.showChangeBoiteModal = false;">NON</button>
          </div>
        </div>

      <div class="changeBoite changeBoiteThrid" v-if="changeBoiteStep == 4">
        <h1 >Veuillez choisir la nouvelle boîte et des moniteurs pour l'élève</h1>
      -->
        <Moniteurs         
          :eleve="eleve"
          :choixDispo="eleve.choixDispo[0]"
          @getEleveInfo="getAllEleves"
          @setNewChoixDispo="setNewChoixDispoEleve"
          @closeModalChoixEleve="closeModalChoixEleve"
          :modalChoixEleve="true"
        />
        <!--
      </div>
      -->
    </Dialog>
    <Dialog v-model:visible="showExamModal" modal :header="'EXAM : ' + this.eleve.fullname" :style="{ width: '50rem' }" >
      <DemandeExam :eleve="eleve" :moniteurs="moniteurs" @updateEleve="selectItem"/>
    </Dialog>

    <Dialog
      v-model:visible="showHeuresProgrammeesDialog"
      modal
      :header="heuresProgrammeesDialogTitle"
      :style="{ width: '70vw', maxWidth: '1000px' }"
    >
      <DataTable :value="heuresProgrammeesList" tableStyle="width: 100%" :rows="10" class="heures-prog-table" :paginator="heuresProgrammeesList.length > 10" :rowClass="heuresProgrammeesRowClass">
        <template #empty>
          <div class="heures-prog-empty">Aucune heure programmée à venir</div>
        </template>
        <Column field="type" header="Type" style="width: 190px; min-width: 190px;">
          <template #body="slotProps">
            <span v-if="slotProps.index === heuresProgrammeesFinTheoriqueIndex" class="type-badge type-badge--fin-theorique">
              Fin théorique de formation
            </span>
            <button
              v-else-if="rdvpDejaPose === false && slotProps.index > heuresProgrammeesFinTheoriqueIndex"
              class="btn-passer-rdvp"
              type="button"
              @click="passerEnRdvPrealable(slotProps.data)"
            >
              Passer en RDV préalable
            </button>
            <span v-else class="type-badge">Conduite</span>
          </template>
        </Column>
        <Column field="ladate" header="Date"></Column>
        <Column field="heure" header="Heure"></Column>
        <Column header="Lieu début">
          <template #body="slotProps">{{ slotProps.data.lieuDeb.nom }}</template>
        </Column>
        <Column header="Lieu fin">
          <template #body="slotProps">{{ slotProps.data.lieuFin.nom }}</template>
        </Column>
        <Column header="Moniteur">
          <template #body="slotProps"><span class="mono-name">{{ slotProps.data.moniteur.fullname }}</span></template>
        </Column>
      </DataTable>
    </Dialog>

    <Dialog
      v-model:visible="showTrameDialog"
      modal
      header="Progression de l'élève"
      :style="{ width: '90vw', maxWidth: '1400px' }"
    >
      <TrameEleve v-if="showTrameDialog" :eleveId="eleve.id" :embedded="true" :viewerIsEleve="false" />
    </Dialog>

    <Dialog v-model:visible="showSemaineHeuresDialog" modal header="Heures réservées par moniteur" :style="{ width: '46rem', maxWidth: '95vw' }">
      <div class="semaine-heures-nav">
        <button class="semaine-heures-arrow" @click="prevWeekSemaineHeures">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <span class="semaine-heures-range">{{ semaineHeuresRangeLabel }}</span>
        <button class="semaine-heures-arrow" @click="nextWeekSemaineHeures">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>

      <div class="semaine-heures-loader" v-if="loadSemaineHeures">
        <LoaderCar width="180px" marginTop="10px" />
      </div>
      <DataTable v-else :value="semaineHeuresList" tableStyle="min-width: 30rem" class="semaine-heures-table">
        <Column header="Moniteur">
          <template #body="slotProps">
            {{ slotProps.data.surnom || (slotProps.data.prenom + " " + slotProps.data.nom) }}
          </template>
        </Column>
        <Column field="heures" header="Heures réservées">
          <template #body="slotProps">
            {{ slotProps.data.heures }}h
          </template>
        </Column>
      </DataTable>
    </Dialog>

  </div>
</template>

<script>
import { nextTick } from 'vue'
import moment from "moment";
import SimpleTypeahead from "vue3-simple-typeahead";
import DispoModalEleve from "@/components/agence/planning/modals/DispoModalEleve.vue";
import Moniteurs from "@/components/eleve/conduite/Moniteurs.vue";
import paiement from "@/components/eleve/Paiement.vue";
import DemandeExam from "@/components/agence/planning/modals/exam/DemandeExam.vue";
import LoaderCar from "@/components/LoaderCar.vue";
import TrameEleve from "@/views/eleve/Conduite/TrameEleve.vue";

export default {

  props:["eleves", "moniteurs", "loadEleve", "setupDispo", "changeDisplayApointment", "getEleves", "cancelEleveChoix", "heuresDispoSemaineType"],
  components: {
    SimpleTypeahead,
    DispoModalEleve,
    Moniteurs,
    paiement,
    DemandeExam,
    LoaderCar,
    TrameEleve
  },

  mounted() {
    this.leleves = this.eleves;
    this.getMontantAcc();
    this.getAgence();
    this.syncModeResa();
  },

  watch: {
    eleves: function(){
      this.leleves = this.eleves;
    }
  },

  data() {
    return {
      dropdownOpen: false,
      showSimuPopup : false,
      showCancelBtnSimu : false,
      eleveSelectSimu : null,
      simuEleves : [],
      loadPaiementBtn : false,
      loadDroitBtn : false,
      showChoixEleve: false,
      auto : false,
      dispoBoite: false,
      paiement : {
        date : null,
        montant: 0,
        mode : null,
        payeur: null
      },
      showBtn : false,
      eleve : "",
      leleves : [],
      showMonoPopup: false,
      droitBtn : false,
      soldeBtn : false,
      droitNumber : 0,
      soldeSoldebtn : true,
      soldeRdvBtn: false,
      rdvsHistorique: [],
      paiementBtn: false,
      accBtn: false,
      aacBtn: false,
      boiteBtn : false,

      indispoChoice : false,
      dispoChoice : false,
      resaChoice : false,
      headerSolde : "",
      montantAcc : 0,
      showEleveParam : true,
      showSoldeParam : false,
      showInfoParam : false,
      showChangeBoiteModal : false,
      changeBoiteStep : 1,
      showChoixMono : false,
      dispoUpdate : false,
      showExamModal : false,
      typeaheadKey: 0,
      skipNextTypeaheadSelect: false,
      moniteurSelectId: null,
      showSemaineHeuresDialog: false,
      semaineHeuresList: [],
      semaineHeuresLundi: null,
      loadSemaineHeures: false,
      showHeuresProgrammeesDialog: false,
      showTrameDialog: false,
    }
  },

  computed: {
    heureAProgEleve(){
      if(this.eleve === '' || this.eleve.heureTot == null){
        return 0;
      }
      return Math.max(0, this.eleve.heureTot);
    },

    heureProgrammeesEleve(){
      if(this.eleve === '' || this.eleve.heuresDejaProg == null){
        return 0;
      }
      return this.eleve.heuresDejaProg;
    },

    heuresProgrammeesList() {
      if (this.eleve === '') {
        return [];
      }
      return (this.eleve.apointments || [])
        .filter((a) =>
          a.done === false &&
          a.cancelRdv === "null" &&
          a.moniteur.fullname !== "Le Simulateur" &&
          a.status !== "rdvp" && a.status !== "rdvp1" && a.status !== "rdvp2" &&
          new Date(a.start.date) > new Date()
        )
        .sort((a, b) => new Date(a.start.date) - new Date(b.start.date));
    },

    // Index (dans heuresProgrammeesList) du rdv après lequel le cumul d'heures programmées
    // atteint "H pour finir la formation" (eleve.heureRestanteTrame) : c'est la "fin théorique"
    heuresProgrammeesFinTheoriqueIndex() {
      if (this.eleve === '' || this.eleve.heureRestanteTrame == null) {
        // Pas de données de trame : on ne peut rien déterminer, aucun cours n'est éligible
        return Infinity;
      }
      if (this.eleve.heureRestanteTrame <= 0) {
        // Formation déjà complète avant même de compter les cours à venir : tous sont "après le seuil"
        return -1;
      }
      let cumul = 0;
      const list = this.heuresProgrammeesList;
      for (let i = 0; i < list.length; i++) {
        const duree = (new Date(list[i].end.date) - new Date(list[i].start.date)) / 3600000;
        cumul += duree;
        if (cumul >= this.eleve.heureRestanteTrame) {
          return i;
        }
      }
      // Jamais atteint même en cumulant tous les cours programmés : aucun cours n'est éligible
      return Infinity;
    },

    // true si le RDV préalable a déjà une date programmée sur un cours
    rdvpDejaPose() {
      if (this.eleve === '') {
        return false;
      }
      return this.eleve.dateRdvp != null && this.eleve.dateRdvp !== "RDVP NON PROG";
    },

    // Mêmes filtres que heuresProgrammeesList, mais appliqués au listing complet
    // "Heures/rendez-vous" (rdvsHistorique) pour y faire apparaître la même logique
    // fin théorique / RDV préalable.
    rdvsHistoriqueFutureConduite() {
      if (this.eleve === '') {
        return [];
      }
      const parseLaDate = (ladate, heure) => {
        const [d, m, y] = ladate.split("/").map(Number);
        const [hh, mn] = heure.split(":").map(Number);
        return new Date(y, m - 1, d, hh, mn);
      };
      return (this.rdvsHistorique || [])
        .filter((r) =>
          r.type === "rdv" &&
          r.termine === false &&
          (r.cancelRdv === null || r.cancelRdv === undefined) &&
          r.moniteur.fullname !== "Le Simulateur"
        )
        .map((r) => ({
          ...r,
          _start: parseLaDate(r.ladate, r.heureDebut),
          _end: parseLaDate(r.ladate, r.heureFin),
        }))
        .filter((r) => r._start > new Date())
        .sort((a, b) => a._start - b._start);
    },

    rdvsHistoriqueFinTheoriqueIndex() {
      if (this.eleve === '' || this.eleve.heureRestanteTrame == null) {
        return Infinity;
      }
      if (this.eleve.heureRestanteTrame <= 0) {
        return -1;
      }
      let cumul = 0;
      const list = this.rdvsHistoriqueFutureConduite;
      for (let i = 0; i < list.length; i++) {
        const duree = (list[i]._end - list[i]._start) / 3600000;
        cumul += duree;
        if (cumul >= this.eleve.heureRestanteTrame) {
          return i;
        }
      }
      return Infinity;
    },

    rdvsHistoriqueFinTheoriqueId() {
      const idx = this.rdvsHistoriqueFinTheoriqueIndex;
      const list = this.rdvsHistoriqueFutureConduite;
      return idx >= 0 && idx < list.length ? list[idx].id : null;
    },

    // Mêmes règles d'apparition que le bouton "classique" (au clic sur l'event) :
    // uniquement le tout dernier cours programmé après la fin théorique, s'il n'y a pas
    // déjà un cours "normal" prévu après lui.
    rdvsHistoriqueRdvpEligibleIds() {
      if (this.rdvpDejaPose) {
        return [];
      }
      const idx = this.rdvsHistoriqueFinTheoriqueIndex;
      const list = this.rdvsHistoriqueFutureConduite;
      if (list.length === 0) {
        return [];
      }
      const lastIdx = list.length - 1;
      return lastIdx > idx ? [list[lastIdx].id] : [];
    },

    heureProgrammeesLabel() {
      if (this.eleve === '' || !this.eleve.aac || this.eleve.rdvpFait) {
        return "H programmées";
      }
      return "H programmées avant RDV préalable";
    },

    heuresProgrammeesDialogTitle() {
      if (this.eleve === '' || !this.eleve.aac || this.eleve.rdvpFait) {
        return "Heures programmées à venir";
      }
      let title = "Heures programmées à venir avant le RDV préalable";
      if (this.eleve.dateRdvp && this.eleve.dateRdvp !== "RDVP NON PROG") {
        title += " du " + this.eleve.dateRdvp;
      }
      return title;
    },

    semaineHeuresRangeLabel(){
      if(this.semaineHeuresLundi == null){
        return "";
      }
      let debut = moment(this.semaineHeuresLundi);
      let fin = moment(this.semaineHeuresLundi).add(6, 'days');
      return debut.format("DD/MM") + " - " + fin.format("DD/MM/YYYY");
    },
  },

  methods: {

    openSemaineHeuresDialog(){
      if(this.semaineHeuresLundi == null){
        this.semaineHeuresLundi = moment().startOf('isoWeek').format("YYYY-MM-DD");
      }
      this.showSemaineHeuresDialog = true;
      this.fetchSemaineHeures();
    },

    prevWeekSemaineHeures(){
      this.semaineHeuresLundi = moment(this.semaineHeuresLundi).subtract(7, 'days').format("YYYY-MM-DD");
      this.fetchSemaineHeures();
    },

    nextWeekSemaineHeures(){
      this.semaineHeuresLundi = moment(this.semaineHeuresLundi).add(7, 'days').format("YYYY-MM-DD");
      this.fetchSemaineHeures();
    },

    fetchSemaineHeures(){
      this.loadSemaineHeures = true;
      window.api
        .post(
          "/moniteurs/planning/semaine",
          {
            lundi: this.semaineHeuresLundi,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.semaineHeuresList = response.data.moniteurs;
          this.loadSemaineHeures = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadSemaineHeures = false;
        });
    },

    deconnexion() {
      this.$store.commit("setUser", null);
      this.$store.commit("setToken", null);
      localStorage.removeItem("user_info");
      localStorage.removeItem("user_access");
    },

    async onDialogShow(){
      await nextTick()
      setTimeout(() => {
        this.$refs.calendarComponent?.refreshCalendar()
      }, 150)
    },

    handleCloseChangeBoite(){
      window.location.reload();
    },

    changeTypeBoiteEleve(){
      let chBoite = null;
      if(this.eleve.boite == 1){
        chBoite = 2;
      }else{
        chBoite = 1;
      }

      window.api
          .get("/eleve/"+this.eleve.id+"/change/boite/"+chBoite, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            if(response.data.eleve == "ok"){
              this.changeBoiteStep = 4;
              this.eleve.choixDispo = "n";
              if(this.eleve.boite == 1){
                this.eleve.boite = 2
              }else{
                this.eleve.boite = 1
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },

    showEleveParamClick(){
      this.showEleveParam = true;
      this.showSoldeParam = false;
      this.showInfoParam = false;
    },

    showSoldeParamClick(){
      this.showEleveParam = false;
      this.showSoldeParam = true;
      this.showInfoParam = false;
    },

    showInfoParamClick(){
      this.showEleveParam = false;
      this.showSoldeParam = false;
      this.showInfoParam = true;
    },

    searchEleve(e){
      
      if(e.input.length == 3 || e.input.length == 6 || e.input.length == 9 || e.input.length == 12 || e.input.length == 15 || e.input.length == 18 || e.input.length == 21){
          window.api
          .get("/eleves/agence/planning/search/"+this.$store.state.user.agence.id+"/"+e.input, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.leleves = response.data.eleves;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    setNewChoixDispoEleve(choix){
      this.eleve.choixDispo[0] = choix;
    },

    getCodeResultSimu(e){

      window.api.get("/eleves/simulateur/"+this.$store.state.user.agence.id, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.simuEleves = response.data.eleves;

          let tabByResult = [];
          if(e.target.value == 'true'){
            tabByResult = this.simuEleves.filter((e) => e.code == "oui");
            this.simuEleves = tabByResult;
          }else if(e.target.value == 'false'){
            tabByResult = this.simuEleves.filter((e) => e.code == "non");
            this.simuEleves = tabByResult;
          }else{
            window.api.get("/eleves/simulateur/"+this.$store.state.user.agence.id, {
              headers: {
                "Authorization": "Bearer " + this.$store.state.token
              },
            }).then(response => {
              this.simuEleves = response.data.eleves;
            }).catch(error => {
              console.log(error)
            })
          }

        }).catch(error => {
          console.log(error)
        })


    },

    selectSimu(){
      this.eleve = this.leleves.find((element) => element.id = this.eleveSelectSimu.id);
      this.eleve.paiements = this.eleve.paiements.reverse();
      this.eleve.apointments = this.eleve.apointments.reverse();
      this.$store.commit("setEleveSelectAgence", this.eleve);
      this.eleve.choixDispo = this.eleveSelectSimu.choixDispo;
      this.showBtn = true;
      this.$emit("setupDispo", this.eleve);
      this.showSimuPopup = false;
    },

    goToHome() {
      this.$router.push({ name: "Home" });
    },

    openModalChoixEleve(){
      this.showChoixEleve = true;
    },

    closeModalChoixEleve(){
      this.showChoixEleve = false;
      if (this.$store.state.user.role.label === 'secretaire') {
        this.showChangeBoiteModal = false;
      }
    },

    dispoIsUpdate(update){
      this.dispoUpdate = update;
    },

    handleClose(){
      if(this.dispoUpdate){
        window.location.reload();
      }else{
        this.dispoChoice = false;
        this.$store.commit('setPlanningSelectChoice', null);
        window.location.reload();
      }
    },

    getAgence(){
      window.api.get("/agences/"+this.$store.state.user.agence.id, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.auto = response.data.autoPlanning;
        }).catch(error => {
          console.log(error)
        })
    },

    setModeResa(e){
      this.resetMoniteurSemaineType();
      if(e.target.value === "INDISPO MONO"){
        this.choiceIndipo();
      }else if(e.target.value === "RESA ELEVE"){
        this.choiceResa();
      }else if(e.target.value === "EXAMEN"){
        this.choiceExam();
      }else if(e.target.value === "EXAMEN BLANC"){
        this.choiceExamBlanc();
      }else if(e.target.value === "SEMAINE TYPE"){
        this.choiceSemaineType();
      }
    },

    setAuto(){
      window.api
          .patch(
            "/agences/" + this.$store.state.user.agence.id,
            {
              autoPlanning: this.auto,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {

          })
          .catch((error) => {
            console.log(error);
          });

    },

    goToFicheEleve(){
      this.$router.push({ name: "trame_eleve", params: { id: this.eleve.id, "return": "agence" }});
    },

    getMontantAcc(){
      window.api.get("/fonctionnalites/6", {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.montantAcc = response.data.montant;
        }).catch(error => {
          console.log(error)
        })
    },

    getAllEleves(){
      this.$emit("getEleves");
    },

    postAac(){
      window.api
        .post(
          "/permis/aac",
          {
            eleve: this.eleve.id,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if(response.data.message != "Solde insufisant"){
            this.$emit("getEleves");
            this.accBtn = false;
            this.eleve.idacc = response.data.id;
            this.eleve.acc = true;
            this.eleve.solde = this.eleve.solde - this.montantAcc;
            this.eleve.paiements.unshift({"date" : response.data.date, "prestation" : response.data.description, "montant" : response.data.montant, "mode" : "cb"})
          }else{
            alert("Solde de l'élève insufisant");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    postOtherPaiement(){
      this.loadPaiementBtn = true;
      window.api
        .post(
          "/other_paiements",
          {
            eleve: "api/utilisateurs/" + this.eleve.id,
            description: "paiement",
            totalAmount: this.paiement.montant * 100,
            mode: this.paiement.mode,
            date: this.paiement.date,
            payeur: this.paiement.payeur,
            archive: false,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          this.$emit("getEleves");
          this.paiement.date = null;
          this.paiement.mode = null;
          this.paiement.payeur = null;
          this.paiementBtn = false;
          this.eleve.solde = this.eleve.solde + this.paiement.montant;
          this.paiement.montant = 0;
          this.loadPaiementBtn = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    syncModeResa(){
      let mode = this.$store.state.modeResa;
      if(mode === "RESA ELEVE"){
        this.choiceResa();
      }else if(mode === "EXAMEN"){
        this.choiceExam();
      }else if(mode === "EXAMEN BLANC"){
        this.choiceExamBlanc();
      }else if(mode === "SEMAINE TYPE"){
        this.choiceSemaineType();
      }else{
        this.choiceIndipo();
      }
    },

    choiceIndipo(){
      this.$store.commit('setShowSearchEleve', false);
      this.cancelChoice();
      this.$store.commit('setPlanningSelectChoice', 'INDISPO');
      this.dispoChoice = false;
      this.resaChoice = false;
    },

    choiceResa(){
      this.$store.commit('setShowSearchEleve', true);
      this.cancelChoice();
      this.$store.commit('setPlanningSelectChoice', 'RESA');
      this.dispoChoice = false;
      this.indispoChoice = false;
      this.$emit("changeDisplayApointment", true);
    },

    choiceExam(){
      this.$store.commit('setShowSearchEleve', true);
      this.cancelChoice();
      this.$store.commit('setPlanningSelectChoice', 'EXAM');
      this.dispoChoice = false;
      this.indispoChoice = false;
      this.$emit("changeDisplayApointment", true);
    },

    choiceExamBlanc(){
      this.$store.commit('setShowSearchEleve', true);
      this.cancelChoice();
      this.$store.commit('setPlanningSelectChoice', 'EXAM BLANC');
      this.dispoChoice = false;
      this.indispoChoice = false;
      this.$emit("changeDisplayApointment", true);
    },

    choiceSemaineType(){
      this.$store.commit('setShowSearchEleve', false);
      this.cancelChoice();
      this.$store.commit('setPlanningSelectChoice', 'SEMAINE TYPE');
      this.dispoChoice = false;
      this.resaChoice = false;
      this.indispoChoice = false;
    },

    formatHeuresDispo(heures){
      return Math.round(heures * 10) / 10;
    },

    formatSolde(v){
      return Number(v).toLocaleString('fr-FR');
    },

    resetMoniteurSemaineType(){
      this.moniteurSelectId = null;
      this.$emit("selectMoniteurSemaineType", null);
    },

    selectMoniteurSemaineType(){
      let moniteur = this.moniteurs.find((m) => m.idMono == this.moniteurSelectId);
      this.$emit("selectMoniteurSemaineType", moniteur || null);
    },

    choiceDispo(){

      if(this.$store.state.planningSelectChoice == 'DISPO'){
        this.$store.commit('setPlanningSelectChoice', null);
      }else{
        this.$store.commit('setPlanningSelectChoice', 'DISPO');
        this.resaChoice = false;
        this.indispoChoice = false;
        //this.$emit("changeDisplayApointment", false);
        if(this.eleve != ""){
          this.dispoBoite = true;
        }
      }
      
    },

    changeBoite(boite){

      console.log(boite)
      this.showChangeBoiteModal = true;
      // if(window.confirm("Voulez-vous changer de type de boite cet elève ?")){
      //   window.api
      //     .patch(
      //       "/utilisateur/" + this.eleve.id,
      //       {
      //         boite: boite,
      //       },
      //       {
      //         headers: {
      //           Authorization: "Bearer " + this.$store.state.token,
      //           "Content-Type": "application/merge-patch+json",
      //         },
      //       }
      //     )
      //     .then(() => {
      //       this.eleve.boite = boite;
      //         let filter = this.leleves.filter((e) => {
      //           e.id == this.eleve.id;
      //         });
      //         filter.push(this.eleve);
      //         this.leleves = filter;
      //         this.boiteBtn = false;
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // }
    },

    setBoite(boite){
      window.api
          .patch(
            "/utilisateur/" + this.eleve.id,
            {
              boite: boite,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            this.eleve.aac = true;
              let filter = this.leleves.filter((e) => {
                e.id == this.eleve.id;
              });
              filter.push(this.eleve);
              this.leleves = filter;
              this.boiteBtn = false;
          })
          .catch((error) => {
            console.log(error);
          });
    },

    unSetAac(){

      if(window.confirm("Voulez-vous retirer la conduite accompagné pour cet élève ?")){
        window.api
          .get(
            "/eleve/" + this.eleve.id + "/change/aac",
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            this.aacBtn = false;
            // Recharge l'élève depuis l'API : aacId côté front doit repartir à null
            // (la FormationAac vient d'être supprimée en base), sinon un futur "Oui"
            // pense qu'elle existe encore et ne la recrée pas (POST /formation_aacs sauté).
            this.selectItem(this.eleve);
          })
          .catch((error) => {
            console.log(error);
          });
      }else{
        this.aacBtn = false;
      }

    },

    setAac(){
      window.api
          .patch(
            "/dossiers/" + this.eleve.dossier.id,
            {
              prevoitAac: true,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            if(this.eleve.aacId == null){
              window.api
              .post(
                "/formation_aacs",
                {
                  eleve: "/api/utilisateurs/"+this.eleve.id,
                  rdvp: null,
                  rdvp1: null,
                  rdvp2: null,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then(() => {
                this.aacBtn = false;
                // Recharge l'élève : aacId doit refléter la FormationAac tout juste créée
                this.selectItem(this.eleve);
              })
              .catch((error) => {
                console.log(error);
              });
            }else{
              this.aacBtn = false;
              this.selectItem(this.eleve);
            }

          })
          .catch((error) => {
            console.log(error);
          });
    },

    setDroit(){
      this.loadDroitBtn = true;
      window.api
          .patch(
            "/agences/" + this.$store.state.user.agence.id,
            {
              droit: this.droitNumber,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            let u = this.$store.state.user;
            u.agence.droit = this.droitNumber;
            this.$store.commit("setUser", u);
            this.droitBtn = false;
            this.loadDroitBtn = false;
          })
          .catch((error) => {
            console.log(error);
          });
    },

    showBoite(){
      if(this.boiteBtn){
        this.boiteBtn = false;
      }else{
        this.boiteBtn = true;
      }
    },

    cancelAcc(){
      if(confirm("Voulez-vous retirer le permis accéléré à cet élève ?")){
        window.api
        .delete("/other_paiements/"+this.eleve.idacc, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          this.$emit("getEleves");
          this.eleve.idacc = 0;
          this.eleve.acc = false;
          
          this.eleve.solde = this.eleve.solde + this.montantAcc;
          let tab = this.eleve.paiements.filter((e) => e.prestation != "permis accéléré");
          this.eleve.paiements = tab;
        })
        .catch((error) => {
          console.log("ERRR::", error.response.data);
        });
      }

    },

    showAcc(){
      if(this.accBtn){
        this.accBtn = false;
      }else{
        this.accBtn = true;
      }
    },

    showAac(){
      if(this.aacBtn){
        this.aacBtn = false;
      }else{
        this.aacBtn = true;
      }
    },

    showPaiement(){
      if(this.paiementBtn){
        this.paiementBtn = false;
      }else{
        this.paiementBtn = true;
        
      }
    },

    changeSoldBtn(){
      if(this.soldeRdvBtn){
        this.soldeSoldebtn = true;
        this.soldeRdvBtn = false;
      }else{
        this.soldeSoldebtn = false;
        this.soldeRdvBtn = true;
        this.getRdvsHistorique();
      }
    },

    getRdvsHistorique(){
      window.api
        .get("/eleve/" + this.eleve.id + "/rdvs/historique", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.rdvsHistorique = response.data.rdvs;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // Rafraîchit l'élève actuellement sélectionné (heures programmées, apointments, etc.)
    // après une réservation/annulation faite depuis le planning, sans passer par selectItem()
    // ni son flag skipNextTypeaheadSelect (réservé au vrai choix dans le typeahead) : sinon un
    // rafraîchissement déclenché ici pouvait être silencieusement ignoré par ce flag.
    refreshSelectedEleve(eleveId) {
      if (!eleveId) {
        return;
      }
      window.api.get("/eleves/agence/planning/selec/" + eleveId, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.eleve = response.data.eleves[0];
          this.eleve.paiements = this.eleve.paiements.reverse();
          this.eleve.apointments = this.eleve.apointments.reverse();
          this.$store.commit("setEleveSelectAgence", this.eleve);
        }).catch(error => {
          console.log(error)
        })
    },

    typeRdvLabel(type){
      const labels = {
        rdv: "Conduite",
        simu: "Simulateur",
        rdvp: "RDV préalable",
        rdvp1: "RDV pédagogique 1",
        rdvp2: "RDV pédagogique 2",
        exam: "Examen",
        "exam blanc": "Examen blanc",
      };
      return labels[type] || type;
    },

    showSolde(){
      if(this.soldeBtn){
        this.soldeBtn = false;
      }else{
        this.soldeBtn = true;
        // L'onglet RDV peut être resté actif depuis une précédente ouverture : on
        // rafraîchit systématiquement pour ne pas réafficher des données périmées.
        if (this.soldeRdvBtn) {
          this.getRdvsHistorique();
        }
      }
    },

    showDroits(){
      if(this.droitBtn){
        this.droitBtn = false;
      }else{
        this.droitBtn = true;
        this.droitNumber = this.$store.state.user.agence.droit;
      }
    },

    showSimu(){
      if(this.showSimuPopup){
        this.showSimuPopup = false;
      }else{
        this.showSimuPopup = true;

        window.api.get("/eleves/simulateur/"+this.$store.state.user.agence.id, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.simuEleves = response.data.eleves;
        }).catch(error => {
          console.log(error)
        })

      }
    },

    cancelMono(){
      this.showMonoPopup = false;
    },

    showMono(type){
      this.$store.commit("setShowMonoPopupConduite", true);
      this.$store.commit("setTypeModalMono", type);
    },

    heuresProgrammeesRowClass(data) {
      const idx = this.heuresProgrammeesList.findIndex((i) => i.id === data.id);
      return idx === this.heuresProgrammeesFinTheoriqueIndex ? 'row-fin-theorique' : null;
    },

    rdvsHistoriqueRowClass(data) {
      return data.id === this.rdvsHistoriqueFinTheoriqueId ? 'row-fin-theorique' : null;
    },

    passerEnRdvPrealable(item) {
      if (!window.confirm("Voulez-vous passer ce RDV en RDV préalable ?")) {
        return;
      }
      window.api
        .put(
          "/aac/apointment/setrdvp/" + item.id,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          alert("Une erreur est survenue, merci de réessayer.");
        });
    },

    selectItem(e){
      // Le remount du typeahead (ci-dessous) ré-applique son "defaultItem", ce qui ré-émet
      // "selectItem" avec le même élève : on ignore ce rappel pour éviter une boucle infinie
      // de remounts et un appel API en double.
      if (this.skipNextTypeaheadSelect) {
        this.skipNextTypeaheadSelect = false;
        return;
      }

      window.api.get("/eleves/agence/planning/selec/" + e.id, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.eleve = response.data.eleves[0];
          this.eleve.paiements = this.eleve.paiements.reverse();
          this.eleve.apointments = this.eleve.apointments.reverse();
          this.$store.commit("setEleveSelectAgence", this.eleve);
          this.showBtn = true;
          this.$emit("setupDispo", this.eleve);
          // Ne pas écraser un mode déjà choisi (EXAM, EXAM BLANC, INDISPO...) : ne forcer
          // "RESA" que si aucun mode n'était actif ou qu'on était déjà en RESA.
          if (this.$store.state.planningSelectChoice === null || this.$store.state.planningSelectChoice === 'RESA') {
            this.$store.commit('setPlanningSelectChoice', 'RESA');
          }
          this.dispoChoice = false;
          this.indispoChoice = false;
          this.$emit("changeDisplayApointment", true);
          document.getElementById("typeahead_id_wrapper").classList.remove("simple-typeahead");
          // Force le remount du typeahead pour que le texte affiché se resynchronise avec
          // l'élève réellement sélectionné (ex: sélection faite depuis un tableau externe
          // comme "Simulateur"/"H à pgmer"/"RDV AAC" plutôt que tapée dans ce champ)
          this.skipNextTypeaheadSelect = true;
          this.typeaheadKey++;

          if (this.$store.state.openHeuresProgrammeesAfterSelect) {
            this.showHeuresProgrammeesDialog = true;
            this.$store.commit('setOpenHeuresProgrammeesAfterSelect', false);
          }
        }).catch(error => {
          console.log(error)
        })
    },


    selectItemSimu(e){
      this.eleveSelectSimu = e;
  
      this.showCancelBtnSimu = true;

    },  

    cancelChoice(){
      this.eleve = "";
      this.showBtn = false;
      this.typeaheadKey++;
      this.$store.commit("setEleveSelectAgence", null);
      this.$emit("cancelEleveChoix");
    },

    cancelChoiceSimu(){
      this.eleveSelectSimu = "";
      this.showCancelBtnSimu = false;

      window.api.get("/eleves/simulateur/"+this.$store.state.user.agence.id, {
              headers: {
                "Authorization": "Bearer " + this.$store.state.token
              },
            }).then(response => {
              this.simuEleves = response.data.eleves;
            }).catch(error => {
              console.log(error)
            })

    },

    setSplitScreen(choix){
      if(choix == "simu"){
        this.$store.commit('setSplitPage', true);
        this.$store.commit('setTitleSplit', "SIMULATEUR");
      }else{
        this.$store.commit('setSplitPage', true);
        this.$store.commit('setTitleSplit', choix);
      }
    }
  },
};
</script>

<style scoped>

/* ===================== CONTENEUR HEADER ===================== */
div.header {
  width: 99%;
  margin: auto;
  margin-bottom: 10px;
  margin-top: 6px;
}

div.header-row {
  display: flex;
  align-items: stretch;
  gap: 16px;
}

div.headerNav {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 12px 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
}

div.headerNavChoix {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 0 1 auto;
}

div.headerNavEleve {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

div.eleveSelecInfo {
  text-align: left;
  flex: 1;
  min-width: 0;
}

div.eleveSelecInfo div.titlePart {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

div.eleveSelecInfo div.titlePart span {
  font-size: 14px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: normal;
  color: #1a1f2e;
}

div.eleveSelecInfo div.titlePart span.eleveTel {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

/* ===================== LABELS DE SECTION ===================== */
div.headerNav div.titlePart {
  margin-bottom: 6px;
}

div.headerNav div.titlePart span {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
  margin-right: 0;
}

/* ===================== SELECTS ===================== */
div.headerNav select {
  height: 40px;
  box-sizing: border-box;
  padding: 9px 32px 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
  margin-right: 0;
  width: 100%;
  max-width: 180px;
}

div.headerNav select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

/* ===================== SEMAINE TYPE : HEURES DISPO ===================== */
div.heuresDispoSemaineWrap {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

span.heuresDispoSemaineBadge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

/* ===================== SECTIONS MODE / RESA ===================== */
div.mode,
div.resa {
  text-align: left;
}

/* ===================== SECTION ÉLÈVE ===================== */
div.eleveSelec {
  text-align: left;
}

div.eleveSelec p {
  font-size: 12px;
  color: #64748b;
  margin-left: 0;
  margin-top: 4px;
}

/* ===================== BARRE DE SÉLECTION ÉLÈVE ===================== */
div.containername {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  margin-bottom: 8px;
}

/* Le champ de recherche rétrécit en priorité, le bouton X reste toujours visible à côté */
div.containername :deep(#typeahead_id_wrapper) {
  flex: 1 1 auto;
  min-width: 0;
}

div.containername > div:last-child {
  flex-shrink: 0;
}

div.select {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 6px;
}

div.select-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

span.select-group-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
}

div.select-group-items {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

div.select-divider {
  width: 1px;
  align-self: stretch;
  background: #e2e8f0;
}

/* ===================== EQUATION HEURES A PROGRAMMER ===================== */
div.heure-equation {
  display: flex;
  align-items: center;
  gap: 8px;
}

div.heure-equation div.heure-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 10px;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

div.heure-equation div.heure-box-clickable {
  cursor: pointer;
  transition: background .15s, border-color .15s;
}

div.heure-equation div.heure-box-clickable:hover {
  background: #e8f0fe;
  border-color: #93c5fd;
}

div.heure-equation span.heure-box-value {
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
}

div.heure-equation span.heure-box-label {
  font-size: 9px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

div.heure-equation span.heure-op {
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
}

div.heure-equation div.heure-box-highlight {
  background: #e8f7ee;
  border-color: #37dd69;
}

div.heure-equation div.heure-box-highlight span.heure-box-value {
  color: #15803d;
}

div.heure-equation div.heure-box-highlight span.heure-box-label {
  color: #16a34a;
}

div.heure-equation button.accActiv {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  gap: 5px;
  min-width: 44px;
  padding: 4px 10px;
  height: auto;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #1a1f2e;
}

div.heure-equation button.accActiv:hover:not(:disabled) {
  background: #e8f0fe;
  border-color: #93c5fd;
  transform: none;
  box-shadow: none;
}

div.heure-equation button.accActiv:disabled {
  opacity: 1;
}

div.solde-card {
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #3b82f6;
  border-radius: 12px;
  cursor: pointer;
}

div.solde-card span.solde-card-value {
  font-size: 16px;
  font-weight: 800;
  color: #1a1f2e;
}

/* ===================== BOUTONS GÉNÉRAUX ===================== */
div.select button.btn,
div.btnMono button.btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 20px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
  letter-spacing: .01em;
}

button.btn-primary {
  background: #3b82f6;
  color: #fff;
  border: none;
}
button.btn-primary:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59,130,246,.3);
}

button.btn-success {
  background: #1a9e6e;
  color: #fff;
  border: none;
}
button.btn-success:hover {
  background: #168a5f;
  transform: translateY(-1px);
}

button.btn-danger {
  background: #fee2e2;
  color: #ef4444;
  border: 1px solid #fca5a5;
}
button.btn-danger:hover {
  background: #ef4444;
  color: #fff;
}

/* Bouton annuler (X) */
div.containername button.btn-primary {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
  font-size: 11px;
  background: #e2e8f0;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
div.containername button.btn-primary:hover {
  background: #ef4444;
  color: #fff;
  transform: none;
  box-shadow: none;
}

/* ===================== LOGO AAC / ÉCLAIR ===================== */
img.logoaac {
  width: 18px;
}

/* ===================== SECTION USER (droite) ===================== */
div.user {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  align-self: center;
}

div.user div.btnMono {
  padding-top: 0;
}

div.btnMono button.btn {
  background: #1a1f2e;
  color: #fff;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .04em;
}

div.user div.btnSemaine {
  padding-top: 0;
}

div.btnSemaine button.btn {
  background: #fff;
  color: #1a1f2e;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .04em;
}

div.btnSemaine button.btn:hover {
  background: #f4f6f9;
  transform: none;
  box-shadow: none;
}

/* ===================== PROFIL / DROPDOWN ===================== */
div.pageInfo {
  display: flex;
  align-items: center;
  height: auto;
  position: static;
  right: auto;
}

div.pageInfo img.goProfile {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

button.profileBtn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a9e6e, #0d7a54);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  transition: box-shadow .15s;
}
button.profileBtn:hover {
  box-shadow: 0 0 0 3px rgba(26,158,110,.2);
}

/* ===================== DROPDOWN CONTENT ===================== */
.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  top: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,.1), 0 4px 12px rgba(0,0,0,.05);
  padding: 6px;
  min-width: 200px;
  z-index: 999;
  line-height: normal;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content a {
  color: #1a1f2e;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  transition: background .1s, color .1s;
  line-height: 1.4;
}

.dropdown-content a:hover {
  background: #f4f6f9;
  color: #3b82f6;
}

.dropdown-content a:first-child {
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 0;
  margin-bottom: 4px;
  padding-bottom: 10px;
}

.dropdown-content a:last-child {
  color: #ef4444;
  font-weight: 600;
  border-top: 1px solid #e2e8f0;
  border-radius: 0;
  margin-top: 4px;
  padding-top: 10px;
}

.dropdown-content a:last-child:hover {
  background: #fee2e2;
  color: #ef4444;
}

/* ===================== SOUS-MENU LÉGENDE ===================== */
.subMenus {
  display: none;
  position: absolute;
  right: 100%;
  top: 0;
  min-width: 220px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,.1);
  padding: 10px 12px;
  z-index: 1000;
  line-height: normal;
}

.dropdown-content .subMenu {
  display: inline-flex;
  width: 100%;
  position: relative;
}

.dropdown-content .subMenu:hover .subMenus {
  display: block;
}

.dropdown-content .subMenu div.subTitleMenu {
  width: 100%;
}

.dropdown-content .subMenu div.subTitleMenu a {
  color: #1a1f2e;
  font-weight: 600;
  font-size: 13px;
  border: none;
  margin: 0;
  padding: 8px 12px;
  border-radius: 8px;
}

.dropdown-content .subMenu div.subTitleMenu a::after {
  content: ' ›';
  color: #94a3b8;
  float: right;
}

.dropdown-content .subMenu div.subTitleMenu a:hover {
  background: #f4f6f9;
  color: #3b82f6;
}

.subMenus p {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
  margin-bottom: 10px;
  padding: 0 4px;
}

/* ===================== LÉGENDE COULEURS ===================== */
div.color {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

div.squareColor {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,.08);
  flex-shrink: 0;
}

.cba                { background: #1a9e6e; }
.cbm                { background: #f59e0b; }
.cdone              { background: #0d9488; }
.cCancelEleve       { background: #ef4444; }
.cIncident          { background: #eab308; }
.cIndispo           { background: #94a3b8; }
.cIndispoMonoPerma  { background: #475569; }
.cExam              { background: #f472b6; }
.cEb                { background: #fb923c; }
.cDispoEleve        { background: #3b82f6; }

/* ===================== VISIBILITÉ ===================== */
.hidding {
  visibility: hidden;
}

/* ===================== MODALES ===================== */
div.headSolde {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button.btnSwitchSolde {
  border-radius: 20px;
  font-size: 12px;
}

div.droitsModal {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

div.droitsModal input,
div.droitsModal select {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  color: #1a1f2e;
  background: #fff;
  outline: none;
}
div.droitsModal input:focus,
div.droitsModal select:focus {
  border-color: #3b82f6;
}

button.btnValideDroit {
  display: block;
  margin: 20px auto 0;
  border-radius: 10px;
}

button.yesBtn {
  margin-right: 2em;
}

select.modePaiement,
select.payeurSelect {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  background: #fff;
  color: #1a1f2e;
  outline: none;
}

select.selectSimu {
  width: 30%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  background: #fff;
  color: #1a1f2e;
  outline: none;
}

div.selector {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
}

div.changeBoite div.choix button {
  margin-top: 2em;
  margin-right: 4em;
}

img.gohome {
  width: 40px;
  cursor: pointer;
}

/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}


/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}

:deep(#typeahead_id) {
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 9px 12px;
  font-family: inherit;
  font-size: 13px;
  width: 100%;
}

.simple-typeahead :deep(.simple-typeahead-list) {
  position: absolute;
  z-index: 9999;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 100%;
  width: max-content;
  max-width: 400px;
}

.simple-typeahead :deep(.simple-typeahead-list-item) {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.simple-typeahead :deep(.simple-typeahead-list-item:hover),
.simple-typeahead
  :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background-color: #f0f4ff;
}

/* ===== Dropdown mobile (tap) ===== */
.dropdown.is-open .dropdown-content {
  display: block;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 960px) {
  div.header-row {
    flex-direction: column;
  }

  div.headerNavChoix {
    flex-wrap: wrap;
    gap: 10px;
  }

  div.headerNavEleve {
    flex-wrap: wrap;
  }

  div.user {
    justify-content: flex-start;
  }
}

@media (max-width: 640px) {
  div.header {
    width: 100%;
    margin: 0;
    padding: 0 0 10px;
  }

  div.headerNav {
    border-radius: 0;
    padding: 10px 14px;
  }

  div.headerNavChoix {
    flex-direction: column;
    gap: 6px;
  }

  div.headerNav select {
    max-width: 100%;
    width: 100%;
  }

  div.user {
    justify-content: flex-start;
  }

  div.eleveSelec div.titlePart,
  div.eleveSelecInfo div.titlePart {
    flex-wrap: wrap;
    font-size: 12px;
  }

  div.select {
    gap: 4px;
  }

  div.select button.btn,
  div.btnMono button.btn {
    font-size: 11px;
    padding: 5px 8px;
  }

  /* Sous-menu légende en position fixe sur mobile */
  .subMenus {
    position: fixed;
    left: 10px;
    right: 10px;
    top: auto;
    bottom: 10px;
    max-height: 55vh;
    overflow-y: auto;
  }

  .dropdown-content {
    min-width: 180px;
    right: 0;
    left: auto;
  }
}

.commentaire-cell {
  font-size: 12px;
  color: #64748b;
  cursor: help;
  border-bottom: 1px dashed #cbd5e1;
}

.rdvPage .table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 12px;
}

.rdvPage .table-wrap--modal {
  max-height: 48vh;
  overflow-y: auto;
}

:deep(.solde-dialog.p-dialog) {
  max-width: 95vw;
}

:deep(.solde-dialog .p-dialog-content) {
  overflow-x: auto;
}

</style>

<style>
/* Non-scoped : le Dialog "Heures réservées par moniteur" téléporte son contenu vers document.body,
   ce qui échappe au CSS scoped ci-dessus. */
div.semaine-heures-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 16px;
}

span.semaine-heures-range {
  font-size: 14px;
  font-weight: 700;
  color: #1a1f2e;
  min-width: 140px;
  text-align: center;
}

button.semaine-heures-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: transparent;
  color: #555;
  cursor: pointer;
  padding: 0;
}

button.semaine-heures-arrow:hover {
  background: #f1f3f4;
}

div.semaine-heures-loader {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}

.semaine-heures-table.p-datatable {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

.semaine-heures-table .p-datatable-thead > tr > th {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

.semaine-heures-table .p-datatable-tbody > tr {
  background: #ffffff;
  transition: background 0.15s;
}

.semaine-heures-table .p-datatable-tbody > tr:hover {
  background: #f9fafb;
}

.semaine-heures-table .p-datatable-tbody > tr > td {
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

.semaine-heures-table .p-datatable-tbody > tr > td:first-child {
  font-weight: 600;
}

.semaine-heures-table .p-datatable-tbody > tr:last-child > td {
  border-bottom: none;
}

/* Non-scoped : le Dialog "Heures programmées à venir" téléporte son contenu vers document.body,
   ce qui échappe au CSS scoped ci-dessus. */
.heures-prog-table.p-datatable {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

.heures-prog-table .p-datatable-thead > tr > th {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
}

.heures-prog-table .p-datatable-tbody > tr {
  background: #ffffff;
  transition: background 0.15s;
}

.heures-prog-table .p-datatable-tbody > tr:hover {
  background: #f9fafb;
}

.heures-prog-table .p-datatable-tbody > tr > td {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

.heures-prog-table .p-datatable-tbody > tr > td:nth-child(2) {
  font-weight: 700;
  color: #1a1f2e;
}

.heures-prog-table span.type-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  background: #e0e7ff;
  color: #4338ca;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.heures-prog-table span.mono-name {
  font-weight: 600;
  color: #1a1f2e;
}

.heures-prog-table span.type-badge--fin-theorique {
  background: #d1fae5;
  color: #047857;
  white-space: normal;
  line-height: 1.3;
}

.heures-prog-table span.type-badge--cancelled {
  background: #fee2e2;
  color: #b91c1c;
  text-decoration: line-through;
}

.heures-prog-table .btn-passer-rdvp {
  padding: 6px 10px;
  border: none;
  border-radius: 8px;
  background: #1a9e6e;
  color: #fff;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .02em;
  cursor: pointer;
  white-space: normal;
  line-height: 1.3;
  transition: background .15s;
}

.heures-prog-table .btn-passer-rdvp:hover {
  background: #158058;
}

.heures-prog-table .p-datatable-tbody > tr.row-fin-theorique {
  background: #ecfdf5;
}

.heures-prog-table .p-datatable-tbody > tr.row-fin-theorique:hover {
  background: #d1fae5;
}

.heures-prog-empty {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 14px;
}

.heures-prog-table .p-paginator {
  background: #ffffff;
  border-top: 1px solid #f3f4f6;
}
</style>